<template>
    <div class="layout">
        <mymask :loaded="loaded"/>
        <Header/>
        <BrandIntro/>
        <ProductIntro/>
        <FlowerList/>
        <CardDownload/>
    </div>
</template>


<script>

import Header from './Header';
import BrandIntro from './BrandIntro';
import ProductIntro from './ProductIntro';
import FlowerList from './FlowerList';
import CardDownload from './CardDownload';

import scrollTo from '../functions/scrollTo'
import mymask from '../subview/Mask.vue';

export default {
    data(){
        return {
            el: "test",
            loaded: false,
            w_width: 0
        }
    },
    components: {
        Header,
        BrandIntro,
        ProductIntro,
        FlowerList,
        CardDownload,
        mymask
    },
    mounted() {
        // console.log('index layout')
        // console.log(this.$route.name)
        setTimeout(()=>{
            this.loaded = true;

        }, 300)
        scrollTo('#'+this.$route.name)
    }
}
// import BrandIntro from './BrandIntro.vue';
// import ProductIntro from './ProductIntro.vue';
// import FlowerList from './FlowerList.vue';
// import CardDownload from './CardDownload.vue';

// import mymask from '../Mask.vue';



// export default {
//     data(){
//         return {
//             el: "test",
//             loaded: false,
//             w_width: 0
//         }
//     },
//     components: {
//         Header,
//         BrandIntro,
//         ProductIntro,
//         FlowerList,
//         CardDownload,
//         mymask
//     },
//     methods: {
// 		scroll_to(el){
//             let el_top =  (this.w_width>768)?($(el).offset().top):($(el).offset().top-50)
// 			$("HTML, BODY").animate({ scrollTop: el_top}, 300);
// 		},
// 		handleResize() {
// 			this.w_width = window.innerWidth;
// 		}
// 	},
    
//     mounted(){
//         setTimeout(()=>{
//             this.loaded = true;
//             this.scroll_to("#"+this.$route.name);
//             console.log($("#"+this.$route.name).offset().top);
//         },300);
        
        
//     },
// 	watch: {
//         '$route' (to, from) {

//             console.log(this.$route.name)
//             if(this.$route.name == 'index'){
//                 let x =setTimeout(()=>{
//                     $("HTML, BODY").animate({ scrollTop: 0}, 500);
//                     clearTimeout(x)
//                 },100);
//                 // clearTimeout(x)
//             }
//             if(this.$route.name == 'product-intro'){
//                 let x =setTimeout(()=>{
//                     this.scroll_to("#product-intro");
//                     clearTimeout(x)
//                 },100);
//                 // clearTimeout(x)
//             }
//             if(this.$route.name == 'brand-intro'){
//                 let x = setTimeout(()=>{
//                     this.scroll_to("#brand-intro");
//                     clearTimeout(x)
//                 },100);
//                 // 
                
//             }
//             if(this.$route.name == 'flower-list'){
//                 let x = setTimeout(()=>{
//                     this.scroll_to("#flower-list");
//                     clearTimeout(x)
//                 },100);
//                 // 
                
//             }
//             if(this.$route.name == 'card-download'){
//                 let x = setTimeout(()=>{
//                     this.scroll_to("#card-download");
//                     clearTimeout(x)
//                 },100);
//                 // 
                
//             }
//         } 
//     },
// 	created() {
// 		window.addEventListener('resize', this.handleResize)
// 		this.handleResize();
// 	},
// 	destroyed() {
// 		window.removeEventListener('resize', this.handleResize)
// 	}
// }
</script>



<style lang="sass">
.layout
    position: relative
    &:before
        content: ''
        // background-image: url('../assets/index-bg.jpg')
        position: fixed
        display: block
        top: 0
        left: 0
        width: 100%
        height: 100%
        background-size: cover
        background-position: center top
        transform: translateZ(0)
        will-change: transform
        z-index: -1000



.flex-section
    display: flex
    flex-wrap: wrap
    z-index: -100
    section
        width: 100%
    @media (max-width: 576px)
        section:nth-child(1)
            order: 2
        section:nth-child(2)
            order: 1
        section:nth-child(3)
            order: 3



</style>



// WEBPACK FOOTER //
// src/Index/layout.vue